var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { s as size, _ as __spreadValues } from "./chunk-JJ6VZ5V7-514ab153.mjs";
import * as React from "react";
import { s as styled, c as color } from "./lib-d8694455.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var SvgComponent = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M31.683 10.667H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a34.717 34.717 0 0 1-.337 5.316H.325a34.914 34.914 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.325 21.333H31.66a30.81 30.81 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      d: "M10.863 23.799C8.228 22.51 4.46 19.953 4.46 14.894c0-5.059.238-7.36.238-7.36H17.03s.238 2.301.238 7.36-3.77 7.616-6.405 8.905Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      d: "M10.863 23.127c-2.417-1.182-5.876-3.528-5.876-8.17 0-4.64.219-6.75.219-6.75H16.52s.218 2.11.218 6.75c0 4.642-3.458 6.988-5.876 8.17Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      d: "M14.45 13.392s-.03.413-.03.894c0 .481.03.894.03.894-1.043-.354-2.332-.361-3.07-.352v2.563h-1.034v-2.563c-.737-.01-2.025-.002-3.069.352 0 0 .03-.413.03-.894 0-.481-.03-.894-.03-.894 1.138.386 2.415.36 3.07.349v-1.61c-.597-.005-1.457.024-2.43.354 0 0 .03-.413.03-.894 0-.482-.03-.895-.03-.895.972.33 1.83.36 2.427.354-.03-1.02-.323-2.304-.323-2.304s.602.047.842.047c.241 0 .843-.047.843-.047s-.292 1.285-.323 2.304c.597.005 1.455-.024 2.426-.354 0 0-.03.413-.03.895 0 .48.03.894.03.894-.972-.33-1.832-.36-2.428-.354v1.61c.654.01 1.931.037 3.069-.35Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      d: "M10.863 17.114c-1.218 0-1.87 1.714-1.87 1.714s-.362-.813-1.355-.813c-.672 0-1.167.607-1.482 1.169 1.223 1.975 3.173 3.194 4.707 3.943 1.534-.75 3.486-1.968 4.708-3.943-.314-.562-.81-1.169-1.482-1.169-.993 0-1.357.813-1.357.813s-.652-1.714-1.87-1.714Z"
    }
  )
), "SvgComponent"), SvgFlagSvk = styled(SvgComponent)`
  ${size}
  ${color}
`, FlagSvk_default = SvgFlagSvk;
export {
  FlagSvk_default as default
};
